import type { ValueEvent } from '@adornis/base/utilTypes.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-loader.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import '@adornis/forms/x-input.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import type { Order } from '../../../db/order.js';

@customElement('ils-order-comment-form')
export class ILSOrderCommentForm extends XDialog<void> {
  static override get element_name() {
    return 'ils-order-comment-form';
  }

  @property({ attribute: false }) order!: Order;

  @state() newVal = '';

  @state() loading = false;

  override connectedCallback() {
    super.connectedCallback();
    this.newVal = this.order.comment ?? '';
  }

  override render() {
    return html`
      <x-flex padding="md" space="md">
        <x-h1> Kommentar bearbeiten </x-h1>
        <x-input
          type="text"
          placeholder="Kommentar hinzufügen..."
          .value=${this.newVal}
          @value-changed=${(e: ValueEvent<string>) => (this.newVal = e.detail.value)}
        ></x-input>
        <x-flex horizontal space="md" space-between>
          <x-button mode="outline" @click=${() => this.cancel()}>Abbrechen</x-button>

          <x-button
            ?disabled=${this.loading}
            @click=${async () => {
              try {
                this.loading = true;

                const safeVal = this.newVal.replace(/<\/?[^>]+(>|$)/g, ''); // trim and remove html

                this.order.comment = safeVal;

                await this.order.save();

                void XSnackbar.show(`Kommentar gespeichert.`);
                void this.close();
              } catch (e) {
                console.error(e);
                void XSnackbar.show(`Kommentar konnte nicht gespeichert werden!`);
              } finally {
                this.loading = false;
              }
            }}
          >
            ${this.loading ? html` <x-loader style="height: 12px; width: 12px;"></x-loader> ` : 'Bestätigen'}
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }
}
